export default __webpack_public_path__ + "static/media/img-gt-mode-gt-bg-kr_kr.95d9cafe.jpg";